import {
  Button,
  Popover,
  PopoverSurface,
  PopoverTrigger,
} from "@fluentui/react-components";
import { PALETTE, type ColorSwatch } from "@onetasklist/shared/colors";
import { getContrastingTextColor } from "@onetasklist/shared";
import ColorPicker from "./ColorPicker";
import "./ColorPickerPopover.scss";

interface ColorPickerPopoverProps {
  colors?: ColorSwatch[];
  /** currently selected hex value or empty string for unset */
  selected?: string;
  onSelect: (hex: string) => void;
  label?: string;
  popoverTitle?: string;
}

export default function ColorPickerPopover({
  colors = PALETTE,
  selected,
  onSelect,
  label = "Colour",
  popoverTitle = "Colour",
}: ColorPickerPopoverProps) {
  return (
    <Popover withArrow positioning="below">
      <PopoverTrigger disableButtonEnhancement>
        <Button
          shape="rounded"
          className="color-picker-popover__trigger"
          aria-label={`${label}: ${selected ?? "unset"}`}
          style={
            selected
              ? {
                  backgroundColor: selected,
                  color: getContrastingTextColor(selected),
                }
              : undefined
          }
          icon={selected ? <></> : <>-</>}
        />
      </PopoverTrigger>
      <PopoverSurface className="color-picker-popover__surface">
        <div className="color-picker-popover__title">{popoverTitle}</div>
        <ColorPicker
          colors={colors}
          selected={selected}
          onSelect={onSelect}
          containerClass="color-picker-popover__grid"
          swatchBaseClass="color-picker-popover__swatch"
          includeUnset
          unsetLabel="-"
        />
      </PopoverSurface>
    </Popover>
  );
}
